// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`SpecCategory model hasMany relations 1`] = `
Array [
  "SpecCategoryDetail",
]
`;
